module.exports = __webpack_public_path__ + "static/media/link.ca7cedf6.svg";